module.exports = __webpack_public_path__ + "static/wand_of_winter-ab930d8a4a585fd7f8d57d5ddeadf0a6.png";